import { Mail, Phone, MapPin, ShieldCheck, Clock } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { LeadForm } from "@/components/site/LeadForm";
import { OFFICES, BRAND } from "@/lib/content";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero
        breadcrumb={[{ label: "Contact" }]}
        eyebrow="Book a confidential briefing"
        title="A 15-minute conversation could change your next hire."
        intro="Tell us about your talent challenge. We'll respond within four business hours — and we'll bring market intelligence relevant to your situation."
      />

      <section className="pb-24">
        <div className="container-bp grid grid-cols-1 gap-12 lg:grid-cols-[1.15fr_0.85fr]">
          <Reveal>
            <div className="rounded-[var(--radius-lg)] border border-[color:var(--bp-border)] bg-[color:var(--bp-surface)] p-7 sm:p-9">
              <h2 className="font-display text-2xl font-semibold text-[color:var(--bp-cream)]">Request your briefing</h2>
              <p className="mt-2 text-[14px] text-[color:var(--bp-text-muted)]">Everything you share is treated in strict confidence.</p>
              <div className="mt-7"><LeadForm type="booking" /></div>
            </div>
          </Reveal>

          <div className="space-y-6">
            <Reveal>
              <div className="rounded-[var(--radius-lg)] border border-[color:var(--bp-border)] bg-[color:var(--bp-surface)] p-7">
                <h3 className="font-display text-lg font-semibold text-[color:var(--bp-cream)]">Direct lines</h3>
                <div className="mt-5 space-y-4">
                  <a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 text-[14px] text-[color:var(--bp-text-muted)] hover:text-[color:var(--bp-teal)]">
                    <Mail className="h-4 w-4 text-[color:var(--bp-teal)]" /> {BRAND.email}
                  </a>
                  {OFFICES.map((o) => (
                    <div key={o.city} className="flex items-start gap-3">
                      <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[color:var(--bp-teal)]" />
                      <div className="text-[13.5px] text-[color:var(--bp-text-muted)]">
                        <p className="font-semibold text-[color:var(--bp-cream)]">{o.city}</p>
                        <p>{o.lines.join(", ")}</p>
                        <a href={`tel:${o.phone.replace(/\s+/g, "")}`} className="inline-flex items-center gap-1.5 pt-1 text-[color:var(--bp-teal)]"><Phone className="h-3.5 w-3.5" /> {o.phone}</a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.08}>
              <div className="rounded-[var(--radius-lg)] border border-[color:var(--bp-border)] bg-[color:var(--bp-surface)] p-7">
                <div className="flex items-center gap-3 text-[14px] text-[color:var(--bp-cream)]"><ShieldCheck className="h-5 w-5 text-[color:var(--bp-teal)]" /> 100% confidential, always</div>
                <div className="mt-4 flex items-center gap-3 text-[14px] text-[color:var(--bp-cream)]"><Clock className="h-5 w-5 text-[color:var(--bp-teal)]" /> Response within 4 business hours</div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
